if (!customElements.get('minico-hero-slider')) {
  class MinicoHeroSlider extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
      this.texts = Array.from(this.querySelectorAll('[data-hero-text]'));
      this.links = Array.from(this.querySelectorAll('[data-hero-link]'));
      this.autoplayMs = Number(this.dataset.autoplay || 0);
      this.index = this.slides.findIndex((slide) => slide.classList.contains('is-active'));
      if (this.index < 0) this.index = 0;

      if (this.slides.length < 2 || this.autoplayMs < 1) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

      this.start();
      document.addEventListener('visibilitychange', this.onVisibilityChange);
    }

    disconnectedCallback() {
      this.stop();
      document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }

    onVisibilityChange = () => {
      if (document.hidden) {
        this.stop();
      } else {
        this.start();
      }
    };

    start() {
      this.stop();
      this.timer = window.setInterval(() => this.next(), this.autoplayMs);
    }

    stop() {
      if (!this.timer) return;
      window.clearInterval(this.timer);
      this.timer = null;
    }

    next() {
      const previous = this.index;
      this.index = (this.index + 1) % this.slides.length;

      this.slides[previous]?.classList.remove('is-active');
      this.texts[previous]?.classList.remove('is-active');
      this.links[previous]?.classList.remove('is-active');
      this.slides[this.index]?.classList.add('is-active');
      this.texts[this.index]?.classList.add('is-active');
      this.links[this.index]?.classList.add('is-active');
    }
  }

  customElements.define('minico-hero-slider', MinicoHeroSlider);
}
